import React, { useState, useEffect } from 'react';
import Select, { MultiValue, SingleValue } from 'react-select';

interface Option {
  label: string;
  value: string;
}

interface AppDropDownPickerProps {
  multiple?: boolean;
  items: Option[];
  placeholder: string;
  value?: string | string[] | null;
  onValueChange: (value: string | string[] | null) => void;
  error?: string;
  containerStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
  dropdownStyle?: React.CSSProperties;
}

const AppDropDownPicker: React.FC<AppDropDownPickerProps> = ({
  multiple = false,
  items,
  placeholder,
  value: valueProp,
  onValueChange,
  error,
  containerStyle,
  textStyle,
  dropdownStyle,
}) => {
  const isControlled = valueProp !== undefined;

  const [internalValue, setInternalValue] = useState<Option | Option[] | null>(null);

  useEffect(() => {
    if (!isControlled) return;

    if (multiple) {
      const vals = Array.isArray(valueProp) ? valueProp : [];
      setInternalValue(items.filter(opt => vals.includes(opt.value)));
    } else {
      const str = typeof valueProp === 'string' ? valueProp : '';
      setInternalValue(items.find(opt => opt.value === str) || null);
    }
  }, [valueProp, items, multiple, isControlled]);

  const selectValue = isControlled ? internalValue : internalValue;

  const handleValueChange = (selected: SingleValue<Option> | MultiValue<Option>) => {
    if (multiple) {
      const arr = Array.isArray(selected) ? selected : [];
      if (!isControlled) {
        setInternalValue(arr);
      }
      onValueChange(arr.map(opt => opt.value));
    } else {
      const single = (selected as Option) || null;
      if (!isControlled) {
        setInternalValue(single);
      }
      onValueChange(single ? single.value : null);
    }
  };

  return (
    <div style={{ marginBottom: '20px', ...containerStyle }}>
      <Select
        isMulti={multiple}
        options={items}
        placeholder={placeholder}
        value={selectValue}
        onChange={handleValueChange}
        styles={{
          control: base => ({
            ...base,
            borderColor: error ? 'red' : '#D0D0D0',
            borderWidth: 1,
            backgroundColor: 'transparent',
            minHeight: '48px',
            borderRadius: '8px',
            ...dropdownStyle,
          }),
          placeholder: base => ({ ...base, ...textStyle }),
        }}
      />
      {error && (
        <p style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
          {error}
        </p>
      )}
    </div>
  );
};

export default AppDropDownPicker;
